import React, { Component } from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap'
import { FormattedMessage, injectIntl } from 'react-intl'

import TitleBar from '../../atoms/TitleBar'

const ContainerStatic = styled(Container)`
  margin-top: 5rem;
  padding-bottom: 4rem;
  overflow-y: auto;
  max-width: 620px !important;
`

const FullWidthLabel = styled(Label)`
  font-size: 20px;
  width: 100%;
`

const ButtonContainer = styled.div`
  margin-bottom: 2rem;
  margin-top: 2rem;
`

class ContactUs extends Component {
  constructor () {
    super()

    this.state = {
      comment: '',
      department: '',
      email: '',
      first_name: '',
      institution: '',
      last_name: '',
      phone: '',
      subscription: true,
      consent: true,
    }

    this.onChangeFunctions = _.reduce(_.keys(this.state), (obj, key) => {
      obj[key] = this.onChange.bind(this, key)
      return obj
    }, {})
  }

  onChangeSubscription = () => {
    this.setState({
      subscription: !this.state.subscription
    })
  }

  onChangeConsent = () => {
    this.setState({
      consent: !this.state.consent
    })
  }

  onChange(fieldName, el) {
    this.setState({
      [fieldName]: el.target.value
    })
  }

  get returnUrl() {
    let protocol = window.location.protocol
    let host = window.location.host
    return `${protocol}//${host}/contato/sucesso`
  }

  render () {
    const { intl } = this.props
    const {
      comment,
      department,
      email,
      first_name,
      institution,
      last_name,
      phone,
      subscription,
      consent
    } = this.state

    return (
      <ContainerStatic>
        <TitleBar>menu.contact</TitleBar>
        <Form action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">
          <Input type="hidden" name="oid" value="00DA0000000CDqV" />
          <Input type="hidden" name="lead_source" value="Contact by Site" />
          <Input type="hidden" name="recordType" value="012A0000000zwgg" />
          <Input type="hidden" name="00N2G00000CIhf7" value="Atlas Agropecuário" />
          <Input type="hidden" name="retURL" value={this.returnUrl} />
          <FormGroup>
            <FullWidthLabel>
              {intl.formatMessage({ id: 'form.first_name' })}
              <Input
                value={first_name}
                type='text'
                id='first_name'
                name='first_name'
                onChange={this.onChangeFunctions['first_name']}
                required />
            </FullWidthLabel>
          </FormGroup>
          <FormGroup>
            <FullWidthLabel>
              {intl.formatMessage({ id: 'form.last_name' })}
              <Input
                value={last_name}
                type='text'
                name='last_name'
                onChange={this.onChangeFunctions['last_name']}
                required />
            </FullWidthLabel>
          </FormGroup>
          <FormGroup>
            <FullWidthLabel>
              {intl.formatMessage({ id: 'form.inst' })}
              <Input
                value={institution}
                type='text'
                name='company'
                onChange={this.onChangeFunctions['institution']}
                required />
            </FullWidthLabel>
          </FormGroup>
          <FormGroup>
            <FullWidthLabel>
              {intl.formatMessage({ id: 'form.dept' })}
              <Input
                value={department}
                type='text'
                name='00N2G00000CIWGo'
                onChange={this.onChangeFunctions['department']} />
            </FullWidthLabel>
          </FormGroup>
          <FormGroup>
            <FullWidthLabel>
              {intl.formatMessage({ id: 'form.email' })}
              <Input
                value={email}
                type='email'
                name='email'
                onChange={this.onChangeFunctions['email']}
                required />
            </FullWidthLabel>
          </FormGroup>
          <FormGroup>
            <FullWidthLabel>
              {intl.formatMessage({ id: 'form.phone' })}
              <Input
                value={phone}
                type='text'
                name='phone'
                onChange={this.onChangeFunctions['phone']} />
            </FullWidthLabel>
          </FormGroup>
          <FormGroup>
            <FullWidthLabel>
              {intl.formatMessage({ id: 'form.cm' })}
              <Input
                rows='4'
                value={comment}
                type='textarea'
                name='Message__c'
                onChange={this.onChangeFunctions['comment']}
                required />
            </FullWidthLabel>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                checked={subscription}
                value="1"
                type='checkbox'
                id='Subscription__c'
                name='Subscription__c'
                onChange={this.onChangeSubscription} />{' '}
              { intl.formatMessage({ id: 'form.subscription' }) }
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                checked={consent}
                value="1"
                type='checkbox'
                id='00N2G00000CJyQj'
                name='00N2G00000CJyQj'
                required
                onChange={this.onChangeConsent} />{' '}
              { intl.formatMessage({ id: 'form.consent' }) }
            </Label>
          </FormGroup>          
          <FormGroup>
            <ButtonContainer>
              <Button name="submit" type='submit' color='success'>
                <FormattedMessage id="form.submit" />
              </Button>
            </ButtonContainer>
          </FormGroup>
        </Form>
      </ContainerStatic>
    )
  }
}

export default injectIntl(ContactUs)



// WEBPACK FOOTER //
// ./src/components/templates/ContactUs/ContactUs.js